import React, { useEffect, useState } from 'react';
import api from '../../api/axios';
import { FiSettings } from 'react-icons/fi';
import { toast } from 'react-toastify';

export default function AdminSettings() {
  const [settings, setSettings] = useState<any>(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get('/admin/settings').then(res => setSettings(res.data));
  }, []);

  const toggle = async (key: string) => {
    const newVal = !settings[key];
    setSaving(true);
    try {
      await api.put('/admin/settings', { [key]: newVal });
      setSettings((prev: any) => ({ ...prev, [key]: newVal }));
      toast.success('Setting updated');
    } catch {
      toast.error('Failed to update setting');
    } finally { setSaving(false); }
  };

  if (!settings) return <div className="empty-state"><p>Loading...</p></div>;

  return (
    <div>
      <h1 style={{ margin: '0 0 20px', fontSize: 22, fontWeight: 700 }}>
        <FiSettings style={{ marginRight: 8 }} />Platform Settings
      </h1>

      <div className="card">
        <div className="card-body" style={{ padding: 24 }}>
          <h3 style={{ fontSize: 16, fontWeight: 700, margin: '0 0 16px' }}>Payment Gateway</h3>

          <div style={{
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            padding: '16px 20px', background: 'var(--gray-50)', borderRadius: 10, marginBottom: 12,
          }}>
            <div>
              <div style={{ fontWeight: 600, fontSize: 15 }}>Tahseeel Test Mode</div>
              <div style={{ fontSize: 13, color: 'var(--gray-400)', marginTop: 2 }}>
                {settings.tahseeel_test_mode
                  ? 'Test mode is ON — payments go to Tahseeel sandbox (no real charges)'
                  : 'Test mode is OFF — payments are LIVE (real charges)'}
              </div>
            </div>
            <button
              onClick={() => toggle('tahseeel_test_mode')}
              disabled={saving}
              style={{
                padding: '8px 20px', borderRadius: 8, border: 'none', cursor: 'pointer',
                fontWeight: 700, fontSize: 13,
                background: settings.tahseeel_test_mode ? '#f59e0b' : '#10b981',
                color: 'white',
              }}>
              {settings.tahseeel_test_mode ? 'TEST' : 'LIVE'}
            </button>
          </div>

          {settings.tahseeel_test_mode && (
            <div style={{ padding: '10px 16px', background: '#fef3c7', border: '1px solid #f59e0b', borderRadius: 8, fontSize: 13, color: '#92400e' }}>
              <strong>Warning:</strong> Subscription payments are using the Tahseeel test/sandbox environment. Switch to LIVE before going to production.
            </div>
          )}

          {!settings.tahseeel_test_mode && (
            <div style={{ padding: '10px 16px', background: '#f0fdf4', border: '1px solid #86efac', borderRadius: 8, fontSize: 13, color: '#166534' }}>
              Tahseeel is in <strong>LIVE</strong> mode. All subscription payments will be charged for real.
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
